<template>
  <div class="p-5 d-flex flex-wrap">
    <div class="text-center col-md-4 d-flex flex-column align-items-center">
      <img
        :src="imageModel.full_url"
        alt="img-model"
        style="max-width: 15rem"
      />
      <span
        v-show="property_selected.lots"
        class="px-3 mb-4 text-white txt-property"
        ><b
          >Unidad {{ property_selected.lots }} -
          {{ property_selected.total_area }}m<sup>2</sup></b
        ></span
      >
      <span
        v-show="property_selected.price && !error_price && !loading_price"
        class="color-palette-4 txt-price"
        ><b>UF {{ $formatCurrency(property_selected.price) }}</b></span
      >
      <small v-show="error_price && !loading_price" class="text-danger">
        Ha ocurrido un error al obtener el precio de la propiedad
      </small>
      <small v-show="loading_price" class="color-palette-4">
        Consultando precio
        <i class="fas fa-circle-notch fa-spin px-1"></i>
      </small>
    </div>
    <div class="col-md-8 px-sm-0">
      <form
        id="reserve-form"
        @submit.prevent="sendReserveForm"
        method="POST"
        class="row"
      >
        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="property" :value="form.property" />
        <input type="hidden" name="entrada" :value="entrada" />

        <div class="col-12">
          <h6 class="mb-1 color-palette-4 font-weight-bold">
            Selección unidad
          </h6>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <v-select-c
            style="border-radius: 9px !important"
            v-model="$v.form.floor.$model"
            :options="floor_select"
            label="text"
            :class="!$v.form.floor.$anyError ? '' : 'form-error'"
            :reduce="(text) => text.id"
            placeholder="Piso"
            @input="filterOrientationFromFloor()"
          >
            <div slot="no-options">No se encontraron datos</div>
          </v-select-c>
          <div class="error-data" v-if="$v.form.floor.$dirty">
            <span v-if="!$v.form.floor.required">Campo necesario</span>
          </div>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <v-select-c
            style="border-radius: 9px !important"
            v-model="$v.form.orientation.$model"
            :options="orientation_select"
            label="text"
            :class="!$v.form.orientation.$anyError ? '' : 'form-error'"
            :reduce="(text) => text.id"
            placeholder="Orientación"
            @input="filterPropertiesSelect()"
          >
            <div slot="no-options">No se encontraron datos</div>
          </v-select-c>
          <div class="error-data" v-if="$v.form.orientation.$dirty">
            <span v-if="!$v.form.orientation.required">Campo necesario</span>
          </div>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <v-select-c
            style="border-radius: 9px !important"
            v-model="$v.form.property.$model"
            :options="property_select"
            label="text"
            :class="!$v.form.property.$anyError ? '' : 'form-error'"
            :reduce="(text) => text.id"
            placeholder="Unidad"
            @input="selectedProperty()"
          >
            <div slot="no-options">No se encontraron datos</div>
          </v-select-c>
          <div class="error-data" v-if="$v.form.property.$dirty">
            <span v-if="!$v.form.property.required">Campo necesario</span>
          </div>
        </div>

        <div class="col-12">
          <h6 class="mt-3 mb-1 color-palette-4 font-weight-bold">
            Datos personales
          </h6>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <input
            type="text"
            placeholder="Nombre Completo"
            name="name"
            v-model.trim="$v.form.name.$model"
            :class="
              !$v.form.name.$anyError
                ? 'form-control input-contacto-1'
                : 'form-control input-contacto-1 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.name.$dirty">
            <span v-if="!$v.form.name.required">Campo necesario</span>
          </div>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <input
            type="text"
            placeholder="R.U.T"
            name="rut"
            v-rut:live
            v-model.trim="$v.form.rut.$model"
            :class="
              !$v.form.rut.$anyError
                ? 'form-control input-contacto-1'
                : 'form-control input-contacto-1 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.rut.$dirty">
            <span v-if="!$v.form.rut.rutValidation || !$v.form.rut.minLength"
              >RUT Inválido</span
            >
          </div>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <input
            type="text"
            placeholder="Email"
            name="email"
            v-model.trim="$v.form.email.$model"
            :class="
              !$v.form.email.$anyError
                ? 'form-control input-contacto-1'
                : 'form-control input-contacto-1 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.email.$dirty">
            <span v-if="!$v.form.email.required">Campo necesario</span>
            <span v-if="!$v.form.email.email">Email inválido</span>
          </div>
        </div>
        <div class="pt-0 pb-2 col-12 col-sm-6">
          <input
            type="text"
            placeholder="Teléfono de contacto"
            name="phone"
            maxlength="9"
            @keypress="onlyNumber"
            v-model.trim="$v.form.phone.$model"
            :class="
              !$v.form.phone.$anyError
                ? 'form-control input-contacto-1'
                : 'form-control input-contacto-1 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.phone.$dirty">
            <span v-if="!$v.form.phone.required">Campo necesario</span>
            <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
            <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-end">
          <button
            type="submit"
            :disabled="formLoading"
            class="px-5 btn btn-form-contact-1"
          >
            {{ btnText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import { rutValidator, rutInputDirective } from "vue-dni";
import PropertyService from "../../services/PropertyService";

import Vue from "vue";
Vue.directive("rut", rutInputDirective);

export default {
  name: "ReserveForm",
  props: {
    project: Number,
    slug: String,
    properties: Array,
    imageModel: "",
  },
  data: () => ({
    csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    properties_filter: [],
    property_selected: [],
    formLoading: false,
    btnText: "Reservar",
    form: {
      name: "",
      rut: "",
      email: "",
      phone: "",
      project_id: 0,
      property: "",
      floor: "",
      orientation: "",
      entrada: "",
    },
    floor_select: [],
    orientation_select: [],
    property_select: [],
    orientations: {
      N: "Norte",
      NE: "Nororiente",
      E: "Oriente",
      SE: "Suroriente",
      S: "Sur",
      SW: "Surponiente",
      W: "Poniente",
      NW: "Norponiente",
    },
    error_price: false,
    loading_price: false,
    entrada: localStorage.getItem("entrada"),
  }),
  mounted() {
    this.properties_filter = this.properties;

    this.properties_filter.map((property) => {
      if (
        this.floor_select.find((floor) => floor.id === property.floor) ===
        undefined
      ) {
        this.floor_select.push({
          id: property.floor,
          text: `Piso ${property.floor}`,
        });
      }
    });
  },
  methods: {
    filterOrientationFromFloor() {
      const newProperties = this.properties_filter.filter(
        (property) => property.floor == this.form.floor
      );

      this.form.orientation = "";
      this.form.property = "";
      this.$v.form.orientation.$reset();
      this.$v.form.property.$reset();
      this.orientation_select = [];
      this.property_select = [];
      this.property_selected = [];

      newProperties.map((property) => {
        if (
          this.orientation_select.find(
            (orientation) => orientation.id === property.orientation
          ) === undefined
        ) {
          this.orientation_select.push({
            id: property.orientation,
            text: this.orientations[property.orientation],
          });
        }
      });
    },
    filterPropertiesSelect() {
      const newProperties = this.properties_filter.filter(
        (property) =>
          property.floor == this.form.floor &&
          property.orientation == this.form.orientation
      );

      this.form.property = "";
      this.$v.form.property.$reset();
      this.property_select = [];
      this.property_selected = [];

      newProperties.map((property) => {
        if (
          this.property_select.find(
            (propSelect) => propSelect.id === property.id
          ) === undefined
        ) {
          this.property_select.push({
            id: property.id,
            text: property.identifier,
          });
        }
      });
    },
    selectedProperty() {
      this.property_selected = this.properties_filter.find(
        (property) => property.id === this.form.property
      );
      this.loading_price = true;
      this.error_price = false;
      PropertyService.validatePriceProperty(this.property_selected.id)
        .then((resp) => {
          this.error_price = false;
          this.property_selected.price = resp.data.new_price;
        })
        .catch((e) => {
          this.error_price = true;
          console.log(e);
        })
        .finally(() => {
          this.loading_price = false;
        });
    },
    sendReserveForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid && !this.error_price) {
        this.btnText = "Enviando...";
        this.formLoading = true;
        const rutaForm = window.BASE_URL + "/add-reserve";
        $("#reserve-form").attr("action", rutaForm).submit();
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  validations: {
    form: {
      rut: {
        required,
        rutValidation: rutValidator,
        minLength: minLength(9),
      },
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      email: {
        required,
        email,
      },
      floor: {
        required,
      },
      orientation: {
        required,
      },
      property: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.input-contacto-1 {
  height: 30px;
  border-radius: 9px;
  font-size: 0.7rem;
}
.error-data {
  font-size: 0.75rem !important;
}
</style>
